module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_round_red.a8c4972e.png";